import { ofType } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import { catchError, debounceTime, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { fetchy } from '@bridebook/web/lib/fetchy';
import { appError } from '@bridebook/web/lib/app/actions';
import {
  EnquiriesActionTypes,
  IFetchEnquiryDates,
} from '@bridebook/web/lib/enquiries/action-types';
import { fetchEnquiryDatesSuccess } from '@bridebook/web/lib/enquiries/actions';
import { IEpicDeps } from '@bridebook/web/lib/types';

const fetchEnquiryDatesEpic = (action$: Observable<IFetchEnquiryDates>, { state$ }: IEpicDeps) =>
  action$.pipe(
    ofType(EnquiriesActionTypes.FETCH_ENQUIRY_DATES),
    debounceTime(500),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {
      const { id: weddingId } = state.weddings.profile;
      const promise = fetchy().authenticated.get('/api/enquiries/get-dates/[weddingId]', {
        weddingId,
      });

      return from(promise).pipe(
        map((payload) => fetchEnquiryDatesSuccess(payload)),
        catchError((error: Error) => of(appError({ error, feature: 'fetchEnquiryDatesEpic' }))),
      );
    }),
  );

export default fetchEnquiryDatesEpic;
